import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {ListItemComponent} from '@abstract/list-items/list-item.component';
import {EquipmentCardEnums, EquipmentCardInterfaces} from '@namespaces/equipment.namespace';

@Component({
    selector: 'tr[app-equipment-list-item]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './equipment-list-item.component.html'
})

export class EquipmentListItemComponent extends ListItemComponent {
    @Input() item: EquipmentCardInterfaces.Card.ListItem;
    @Input() selectedValues: number[] = [];

    public statuses = EquipmentCardEnums.EquipmentStatus;
}
